import React, { Suspense, lazy } from "react";
// import loadable from "@loadable/component";
import { Route, Switch } from "react-router-dom";

// 언어 정보
// import { LocaleContext } from "contexts/locale-context";
import { LocaleProvider } from "contexts/locale-context";
import Translate from "locale/Translate";

import Core from "containers/Core";
import Layout from "component/layout/Layout";

// 코드 스플리팅
// 회원가입
const JoinPage = lazy(() => import("pages/membership/JoinPage"));
const JoinSuccess = lazy(() => import("pages/membership/JoinSuccess"));
// 로그인, 아이디찾기, 비밀번호찾기
const LoginPage = lazy(() => import("pages/login/LoginPage"));
const IdFindPage = lazy(() => import("pages/login/IdFindPage"));
const PwFindPage = lazy(() => import("pages/login/PwFindPage"));
const PwChangePage = lazy(() => import("pages/login/PwChangePage"));
// 메인
const Main = lazy(() => import("pages/main/Main")); // 메인페이지
const IntroducePage = lazy(() => import("pages/about/IntroducePage")); // 센터소개
const MeaningPage = lazy(() => import("pages/about/MeaningPage")); // 임상시험 참여의 의의
const ProcessPage = lazy(() => import("pages/about/ProcessPage")); // 절차안내
const SubjectGuidePage = lazy(() => import("pages/about/SubjectGuidePage")); // 절차안내
const AppGuidePage = lazy(() => import("pages/about/AppGuidePage")); // 서울대학교병원 앱 이용 안내

const FaqPage = lazy(() => import("pages/contact/FaqPage"));
const LocationPage = lazy(() => import("pages/contact/LocationPage"));
const RecruitListPage = lazy(() => import("pages/studyInfo/RecruitListPage"));
const RecruitWritePage = lazy(() => import("pages/studyInfo/RecruitWritePage"));
const RecruitMemberPage = lazy(() =>
  import("pages/studyInfo/RecruitMemberPage")
);
const RecruitViewPage = lazy(() => import("pages/studyInfo/RecruitViewPage"));

// 마이페이지
const UserInfoPage = lazy(() => import("pages/myInfo/UserInfoPage"));
const UserInfoPwConfirmPage = lazy(() => import("pages/myInfo/UserInfoPwConfirmPage"));
const UserModifyPage = lazy(() => import("pages/myInfo/UserModifyPage"));
const UserApplyPage = lazy(() => import("pages/myInfo/UserApplyPage"));
const ApplyModifyPage = lazy(() => import("pages/myInfo/ApplyModifyPage"));
const UserHistoryPage = lazy(() => import("pages/myInfo/UserHistoryPage"));
const WithdrawalPage = lazy(() => import("pages/myInfo/WithdrawalPage"));
const QnaListPage = lazy(() => import("pages/qna/QnaListPage"));
const QnaWritePage = lazy(() => import("pages/qna/QnaWritePage"));
const QnaViewPage = lazy(() => import("pages/qna/QnaViewPage"));
const ErrorPage = lazy(() => import("pages/ErrorPage"));

const App = () => {
  return (
    <LocaleProvider>
      <Translate>
        <Suspense fallback={<Layout noTitle={true}>로딩중...</Layout>}>
          <Switch>
            <Route path="/" exact component={Main} />
            <Route path="/:locale/main" exact component={Main} />
            {/* 로그인, 아이디찾기, 비밀번호 찾기 */}
            <Route path="/:locale/login" exact component={LoginPage} />
            <Route path="/:locale/login/idfind" exact component={IdFindPage} />
            <Route path="/:locale/login/pwfind" exact component={PwFindPage} />
            <Route
              path="/:locale/login/pwChange"
              exact
              component={PwChangePage}
            />
            {/* 회원가입 */}
            <Route path="/:locale/membership/join" exact component={JoinPage} />
            <Route
              path="/:locale/membership/write"
              exact
              component={JoinSuccess}
            />
            {/* 임상시험센터 */}
            <Route
              path="/:locale/about/introduce"
              exact
              component={IntroducePage}
            />
            <Route
              path="/:locale/about/meaning"
              exact
              component={MeaningPage}
            />
            <Route
              path="/:locale/about/process"
              exact
              component={ProcessPage}
            />
            <Route
              path="/:locale/about/subjectguide"
              exact
              component={SubjectGuidePage}
            />
            <Route
              path="/:locale/about/appguide"
              exact
              component={AppGuidePage}
            />
            <Route path="/:locale/contact/faq" exact component={FaqPage} />
            <Route
              path="/:locale/contact/location"
              exact
              component={LocationPage}
            />
            {/* 임상시험 모집정보 */}
            <Route
              path="/:locale/studyinfo/recruitment"
              exact
              component={RecruitListPage}
            />
            <Route
              path="/:locale/studyinfo/recruitmentWrite"
              exact
              component={RecruitWritePage}
            />
            <Route
              path="/:locale/studyinfo/recruitmentWriteMember"
              exact
              component={RecruitMemberPage}
            />
            <Route
              path="/:locale/studyinfo/recruitmentView"
              exact
              component={RecruitViewPage}
            />
            {/* 마이페이지 */}
            <Route
              path="/:locale/myinfo/userinfo"
              exact
              component={UserInfoPage}
            />
            <Route
              path="/:locale/myinfo/userInfoPwConfirm"
              exact
              component={UserInfoPwConfirmPage}
            />
            <Route
              path="/:locale/myinfo/userModify"
              exact
              component={UserModifyPage}
            />
            <Route
              path="/:locale/myinfo/apply"
              exact
              component={UserApplyPage}
            />
            <Route
              path="/:locale/myinfo/applyModify"
              exact
              component={ApplyModifyPage}
            />
            <Route
              path="/:locale/myinfo/history"
              exact
              component={UserHistoryPage}
            />
            <Route
              path="/:locale/myinfo/withdrawal"
              exact
              component={WithdrawalPage}
            />
            <Route path="/:locale/myinfo/qna" exact component={QnaListPage} />
            <Route
              path="/:locale/myinfo/qnaWrite"
              exact
              component={QnaWritePage}
            />
            <Route
              path="/:locale/myinfo/qnaView"
              exact
              component={QnaViewPage}
            />
            {/* path 를 따로 정의하지 않으면 모든 상황에 렌더링됨 */}
            <Route component={ErrorPage} />
          </Switch>
          <Core />
        </Suspense>
      </Translate>
    </LocaleProvider>
  );
};

export default App;
